import replaceStringWithVars from 'src/universal/utils/replaceStringWithVars';

export const buildCompareCtaDtm = (shortNames, dtm, categoriesOfCards = []) => {
  const productNames = shortNames.reduce((accumulator, name) => {
    let cardObj = null;
    // we use for loop so we can easily break off the loop early if needed.
    for (let i = 0; i < categoriesOfCards.length; i++) {
      cardObj = (categoriesOfCards[i].cards || []).find(
        card => card?.shortName === name
      );
      if (cardObj) {
        break;
      }
    }
    accumulator.push(cardObj?.dtmProductName || name);
    return accumulator;
  }, []);

  return {
    ...dtm,
    eventAsset: replaceStringWithVars({
      varsObject: {
        numOfCards: shortNames.length,
        productNames: productNames.join('_')
      },
      string: dtm?.eventAsset
    })
  };
};
